/**
 * Bewaarde weergavekeuze van de renovatieticketlijst: "recent" (vlakke lijst,
 * nieuwste eerst) of "project" (gegroepeerd per renovatieproject en -onderdeel).
 * De keuze staat in localStorage, zodat wie per project werkt daar terugkomt.
 *
 * @module RenoHelpdesk/Hooks/UseRenoListViewMode
 */

import { useCallback, useState } from 'react';

export type RenoListViewMode = 'recent' | 'project';

const STORAGE_KEY = 'renoListViewModeV1';

export function useRenoListViewMode() {
  const [viewMode, setViewModeState] = useState<RenoListViewMode>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'project' ? 'project' : 'recent';
    } catch {
      return 'recent';
    }
  });

  const setViewMode = useCallback((mode: RenoListViewMode) => {
    setViewModeState(mode);
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      // localStorage kan geblokkeerd zijn; de weergave werkt dan zonder bewaren.
    }
  }, []);

  return { viewMode, setViewMode };
}
